import React, { useEffect } from 'react'
import { HeaderStars, Image, Link, DemoBanner } from 'newComponents'
import './styles.scss'
import { ReactComponent as SphereHollow } from '../../../images/pricing/new/hero-orb-hollow.svg'

const On24 = () => {
  useEffect(() => {
    On24Script()
  })

  const On24Script = () => {
    const script = document.createElement('script')
    const container = document.getElementById('on24Container')

    script.src = 'https://gateway.on24.com/view/orion/engagement-hub/dist/embed/embed.js'
    script.id = 'On24LoadingScript'
    script.async = true
    script.dataset.width = '100%'
    script.dataset.height = 'auto'
    script.dataset.url = 'https://gateway.on24.com/wcc/eh/3099907/launchdarkly-webinars/'

    container.appendChild(script)
  }

  return (
    <div className="on-24-webinar">
      <div className="on-24-webinar-inner-background" />
      <HeaderStars />
      <div className="on-24-header container">
        <h6>Webinars</h6>
        <h1>LaunchDarkly Webinars</h1>
        <p>Register for upcoming webinars or watch the on-demand recording if you missed a live session.</p>
      </div>
      <div className="container on-24-webinar-container" id="on24Container" />
      <div className="on-24-explore-more container">
        <h2>Explore more</h2>
        <div className="on-24-explore-more-items">
          <Link to="https://launchdarkly.com/galaxy/">
            <div className="on-24-explore-more-item">
              <div className="on-24-explore-more-item-image">
                <Image image="https://images.prismic.io/launchdarkly/9b8e62a6-88d6-4070-9ad9-ae02afce72f4_Galaxy%402x.jpg?auto=compress,format" />
              </div>
              <div className="on-24-explore-more-item-content">
                <h6>Galaxy</h6>
                <h5>The interactive user conference for software and product innovators</h5>
              </div>
            </div>
          </Link>

          <Link to="https://launchdarkly.com/roi-feature-management/">
            <div className="on-24-explore-more-item">
              <div className="on-24-explore-more-item-image">
                <Image image="https://images.prismic.io/launchdarkly/39291f61-9181-445e-b263-6b20891f8c30_webinar-image-2png.png?auto=compress,format" />
              </div>
              <div className="on-24-explore-more-item-content">
                <h6>THE ROI OF FEATURE MANAGEMENT</h6>
                <h5>LaunchDarkly feature flags increase software stability and delivery speed</h5>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <SphereHollow className="sphere-hollow" />
      <DemoBanner />
    </div>
  )
}

export default On24
